// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--VUGIP","contentWrapper":"Footer-module--contentWrapper--1b_KF"};